import { Truck01, Container, AlarmClockCheck, CheckCircle, Package, Zap, Signal01 } from '@untitled-ui/icons-react/build/cjs';

export const SERVICE_TYPES = [
    { label: 'LTL', title: 'Less Than Truckload', value: 'ltl', icon: Package },
    { label: 'FTL', title: 'Full Truckload', value: 'ftl', icon: Truck01 },
];

// Customer-chosen speed on a quote request (meeting 2026-10-01), stored on quotes.serviceLevel.
// Labels are i18n keys.
export const SERVICE_LEVELS = [
    { labelKey: 'MyQuote.Service_Level_Standard', titleKey: 'MyQuote.Service_Level_Standard_Desc', value: 'standard', icon: AlarmClockCheck },
    { labelKey: 'MyQuote.Service_Level_Expedited', titleKey: 'MyQuote.Service_Level_Expedited_Desc', value: 'expedited', icon: Zap },
] as const;

export const URGENCY_OPTIONS = [
    { label: 'Live', title: 'Live Quote', value: 'live', icon: Zap },
    { label: 'QFR', title: 'Quote For Reference', value: 'qfr', icon: Signal01 },
];

export const SENSITIVITY_OPTIONS = [
    { label: 'Flexible', value: 'flexible', icon: Container },
    { label: 'Rigid', value: 'rigid', icon: AlarmClockCheck },
];

export const AVAILABILITY_OPTIONS = [
    { label: 'Today or Tomorrow', value: 'today_tomorrow' },
    { label: 'Anytime This Week', value: 'this_week' },
    { label: 'Anytime Next Week', value: 'next_week' },
];

export const FLEXIBLE_OPTIONS = {
    TODAY_OR_TOMORROW: 'today_tomorrow',
    ANYTIME_THIS_WEEK: 'this_week',
    NEXT_WEEK: 'next_week',
};

export const SENSITIVITY = {
    FLEXIBLE: 'flexible',
    RIGID: 'rigid',
    READY_NOW: 'ready_now',
};

export const PICKUP_SENSITIVITY_OPTIONS = [
    { label: 'Flexible', value: 'flexible', icon: Package },
    { label: 'Rigid', value: 'rigid', icon: AlarmClockCheck },
    { label: 'Ready Now', value: 'ready_now', icon: CheckCircle },
];

export const PICKUP_WINDOW_TOOLTIP: Record<string, string> = {
    open: 'Available any time during business hours — no restriction sent to carrier',
    ready_time: 'Carrier will be informed the shipment is ready from this time. Pickup can happen anytime within the window.',
    appointment: 'Shipper requires a confirmed appointment. Carrier must book this time slot in advance.',
};

export const DELIVERY_WINDOW_TOOLTIP: Record<string, string> = {
    open: 'Available any time during business hours — no restriction sent to carrier',
    delivery_time: 'Carrier will be informed the shipment is ready from this time. Delivery can happen anytime within the window.',
    appointment: 'Consignee requires a confirmed appointment. Carrier must book this time slot in advance.',
};
